import React from "react";
import logo from "../../assets/icon.svg";
import img from "../../assets/icon.svg";

import heroIllustration from "../../assets/icon.svg"; // optional - replace or remove if you don't have it

export default function About() {
  return (
    <section id="about" className="bg-bgray py-16">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Left: copy */}
        <div className="space-y-6">
          <div className="flex items-center gap-3">
            <img src={logo} alt="Interlink logo" className="h-11 w-11" />
            <h2 className="text-3xl sm:text-4xl font-semibold text-dark leading-tight">
              What is <span className="text-earth">Inter</span><span className="text-accent">link</span>?
            </h2>
          </div>

          <p className="text-lg m-0">
            <span className="font-semibold text-primary">Interlink</span> is a
            cross-disciplinary action club where students from different majors
            learn from each other, collaborate on real projects, and turn
            curiosity into practical outcomes. 
          </p>
          
          <ul className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-3">
            <li className="flex items-start gap-3">
              <span className="inline-flex items-center justify-center h-8 w-8 rounded-md bg-accent/10 text-accent font-semibold">
                ✓
              </span>
              <div>
                <div className="font-semibold">Hands-on Workshops</div>
                <div className="text-sm text-dark/70">Tools, labs, skill sprints</div>
              </div>
            </li>

            <li className="flex items-start gap-3">
              <span className="inline-flex items-center justify-center h-8 w-8 rounded-md bg-accent/10 text-accent font-semibold">
                ✓
              </span>
              <div>
                <div className="font-semibold">Inter-major Projects</div>
                <div className="text-sm text-dark/70">Teams from different majors</div>
              </div>
            </li>

            <li className="flex items-start gap-3">
              <span className="inline-flex items-center justify-center h-8 w-8 rounded-md bg-accent/10 text-accent font-semibold">
                ✓
              </span>
              <div>
                <div className="font-semibold">Competitions & Hackathons</div>
                <div className="text-sm text-dark/70">Represent the university</div>
              </div>
            </li>

            <li className="flex items-start gap-3">
              <span className="inline-flex items-center justify-center h-8 w-8 rounded-md bg-accent/10 text-accent font-semibold">
                ✓
              </span>
              <div>
                <div className="font-semibold">Community Events</div>
                <div className="text-sm text-dark/70">Exhibitions, talks, socials</div>
              </div>
            </li>
          </ul>

          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <a
              href="#join"
              className="inline-block bg-primary text-white px-5 py-3 rounded-lg font-medium shadow-md hover:opacity-90 hover:-translate-y-0.5 transition-all"
            >
              Join Interlink
            </a>
          </div>
        </div>

        {/* Right: illustration / visual */}
        <div className="flex items-center justify-center">
          {/* Use an SVG illustration if you have one. If not, show a simple geometric placeholder. */}
          {typeof heroIllustration !== "undefined" ? (
            <img
              src={img}
              alt="Students collaborating — illustration"
              className="max-w-full h-auto rounded-xl shadow-sm"
            />
          ) : (
            <div className="w-full max-w-md aspect-[4/3] rounded-xl bg-gradient-to-tr from-accent/5 to-primary/5 border border-accent/10 flex items-center justify-center">
              <div className="text-center p-6">
                <div className="text-2xl font-bold">Interdisciplinary</div>
                <div className="mt-2 text-sm text-dark/60">Collaboration & Projects</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
